module.exports = __webpack_public_path__ + "static/media/testimony4.f6f5f9f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/testimony4.jpg
// module id = 278
// module chunks = 0